/* globals jQuery, _ */

import Model from './base';
import Location from './location';
import VenueSet from '../collections/venue-set';

const $ = jQuery;
const { bindAll } = _;

export default Model.extend( {
	key: 'trip',

	defaults: {
		title: '',
		origin: null,
		origin_id: null,
		destination: null,
		destination_id: null,
		area: 10,
	},

	getId: function() {
		var id = this.get( 'origin_id' ) || this.get( 'origin' );

		if ( this.get( 'type' ) === 'road' ) {
			id += '|' + ( this.get( 'destination_id' ) || this.get( 'destination' ) );
		}

		return btoa( id );
	},

	initialize: function() {
		bindAll( this, 'assignOrigin', 'assignDestination' );

		this.assignOrigin();
		this.assignDestination();
		this.stops = new VenueSet( this.get( 'stops' ) || [] );

		this.on( 'change:origin_id', this.assignOrigin );
		this.on( 'change:destination_id', this.assignDestination );

		this.origin.onChanged( 'lat lng', () => this.set( 'origin_position', this.origin.getPosition() ) );
		this.destination.onChanged( 'lat lng', () => this.set( 'destination_position', this.destination.getPosition() ) );

		this.listenTo( this.stops, 'reset update', () => this.trigger( 'change:stops' ) );
	},

	_assignLocation: function( key ) {
		var attributes = {
			name: this.get( key ) || '',
			id: this.get( `${key}_id` ) || '',
			coords: this.get( `${key}_position` ) || {},
		};

		if ( this[ key ] ) {
			this[ key ].set( attributes );
			return;
		}

		this[ key ] = new Location( attributes );
	},

	assignOrigin: function() {
		this._assignLocation( 'origin' );
	},

	assignDestination: function() {
		this._assignLocation( 'destination' );
	},

	_bindLocation: function( key ) {
		return [
			`change:${key}`,
			() => ( this.get( key ) || '' ).replace( /^([^,]+).*$/, '$1' ),
		];
	},

	bindOrigin: function() {
		return this._bindLocation( 'origin' );
	},

	bindDestination: function() {
		return this._bindLocation( 'destination' );
	},

	bindSummary: function() {
		return [
			'change:origin change:destination',
			() => {
				var origin = this.get( 'origin' );

				var destination;
				if ( this.get( 'type' ) === 'road' ) {
					destination = this.get( 'destination' );
				}

				if ( ! destination ) {
					return origin;
				}

				return `${origin} to ${destination}`;
			},
		];
	},

	bindArea: function() {
		return [
			'change:area',
			() => this.get( 'area' ) + ' km',
		];
	},

	bindCategory: function() {
		return [
			'change:category',
			( $elm, options ) => {
				if ( options.use === 'icon' ) {
					return;
				}
				return this.get( 'category' );
			},
		];
	},

	bindStops: function() {
		return [
			'change:stops',
			( $elm, options ) => {
				var count = this.stops.length;

				if ( options.nform ) {
					let nform = options.nform.split( ',' );
					count = `${count} ${count === 1 ? nform[ 0 ] : nform[ 1 ]}`;
				}

				return count;
			},
		];
	},

	bindDistance: function() {
		return [
			'change:stops change:distance',
			() => {
				var meters = this.get( 'distance' );

				if ( meters < 1000 ) {
					return Math.round( meters ) + ' m';
				}

				return ( meters / 1000 ).toFixed( 1 ).replace( '.0', '' ) + ' km';
			},
		];
	},

	bindDirections: function() {
		return [
			'change:origin_id change:destination_id change:stops',
			$elm => {
				var url = 'https://www.google.com/maps/dir/';

				var params = {
					api: 1,
				};

				if ( this.get( 'origin_id' ) ) {
					params.origin_place_id = this.get( 'origin_id' );
				} else {
					params.origin = this.get( 'origin' );
				}

				if ( this.get( 'destination_id' ) ) {
					params.destination_place_id = this.get( 'destination_id' );
				} else {
					params.destination = this.get( 'destination' );
				}

				if ( this.stops.length > 0 ) {
					let points = [];
					this.stops.each( stop => {
						points.push( `${stop.get( 'lat' )},${stop.get( 'lng' )}` );
					} );

					params.waypoints = points.join( '|' );
				}

				$elm.attr( 'href', url + $.param( params ) );
			},
		];
	},
} );
